import React, { useEffect } from 'react';
import DashboardCard from 'components/DashboardCard/DashboardCard';
import { Description } from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from '@tanstack/react-router';
import { DataGrid } from '@mui/x-data-grid';
import { actions } from '../ClientView.redux';
import NumberedDataGridPagination from 'components/NumberedDataGridPagination';

const ClientReports = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { client_id } = useParams({ from: '/clients/view/$client_id' });
    const hasLoaded = useSelector((state) => state.clientView.reportsPreviouslyLoaded);
    const loading = useSelector((state) => state.clientView.reportsLoading);
    const reports = useSelector((state) => state.clientView.reports);
    const loadReports = (clientID) => dispatch(actions.loadReports(clientID));

    const columns = [
        { field: 'patient_name', headerName: 'Patient', flex: 1, minWidth: 170, sortable: false },
        { field: 'date_updated', headerName: 'Update Date', flex: 1, minWidth: 150, sortable: false },
        { field: 'date_created', headerName: 'Create Date', flex: 1, minWidth: 150, sortable: false },
        { field: 'urpt_name', headerName: 'Report Name', flex: 1, minWidth: 180, sortable: false },
        { field: 'template_name', headerName: 'Template', flex: 1, minWidth: 170, sortable: false },
        { field: 'created_by', headerName: 'Created By', flex: 1, minWidth: 150, sortable: false },
        { field: 'updated_by', headerName: 'Updated by', flex: 1, minWidth: 150, sortable: false },
    ];

    useEffect(() => {
        if (!hasLoaded && !loading) {
            loadReports(client_id);
        }
    }, [loadReports, client_id, hasLoaded, loading]);

    return (
        <DashboardCard
            color={'amber'}
            icon={<Description />}
            topContent={'Reports'}
            topLabel="Click a report to view or edit"
            size="xl"
        >
            <div style={{ width: '100%' }}>
                <DataGrid
                    rows={reports}
                    columns={columns}
                    getRowId={(row) => row.urpt_id}
                    pagination
                    pageSizeOptions={[5, 10, 20, 50]}
                    initialState={{
                        pagination: {
                            paginationModel: { page: 0, pageSize: 10 },
                        },
                    }}
                    loading={loading}
                    disableRowSelectionOnClick
                    disableColumnMenu
                    disableCellFocus
                    sx={{
                        '& .MuiDataGrid-row': { cursor: 'pointer' },
                        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none' },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
                            outline: 'none',
                        },
                    }}
                    slots={{ pagination: NumberedDataGridPagination }}
                    onRowClick={(params) => navigate({ to: `/reports/edit/${params.row.urpt_id}` })}
                    autoHeight
                />
            </div>
        </DashboardCard>
    );
};

export default ClientReports;
